// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_vQkGA","footerBox":"index_footerBox_zwO63","footerItem":"index_footerItem_n32sh","hairlines":"index_hairlines_mUomV","footerLink":"index_footerLink_FGyJu"};